var map = {
	"./28453ad696e1263c80ddb385a95ede9a.jpg": 3637,
	"./6513cb53d2825f3f7e619f636d719937.png": 1565,
	"./button-almost-bad.svg": 4746,
	"./button-almost-good.svg": 9014,
	"./button-bad.svg": 1743,
	"./button-burger.svg": 3477,
	"./button-close.svg": 2794,
	"./button-good.svg": 7609,
	"./button-normal.svg": 1259,
	"./button-phone-call.svg": 8395,
	"./button-phone.svg": 2622,
	"./button-smiles.svg": 9733,
	"./button-thumb-down.svg": 3991,
	"./button-thumb-up.svg": 840,
	"./button-video.svg": 9587,
	"./icon-arrow-left.svg": 4420,
	"./icon-attachment.svg": 1024,
	"./icon-attention.svg": 2971,
	"./icon-burger.svg": 3832,
	"./icon-call.svg": 9435,
	"./icon-check-big.svg": 4872,
	"./icon-check.svg": 109,
	"./icon-click.svg": 5973,
	"./icon-close-big.svg": 5940,
	"./icon-close.svg": 5817,
	"./icon-copy.svg": 4396,
	"./icon-default-avatar.svg": 9280,
	"./icon-delete.svg": 5742,
	"./icon-delete2.svg": 4816,
	"./icon-edit.svg": 8467,
	"./icon-eyes.svg": 3489,
	"./icon-go-back.svg": 7891,
	"./icon-incoming-call.svg": 900,
	"./icon-incoming-group-call.svg": 5134,
	"./icon-link.svg": 1835,
	"./icon-mic.svg": 520,
	"./icon-microphone.svg": 7739,
	"./icon-pause.svg": 6159,
	"./icon-play-small.svg": 7547,
	"./icon-play.svg": 3641,
	"./icon-quotes.svg": 4068,
	"./icon-resend.svg": 2162,
	"./icon-send.svg": 1669,
	"./icon-shuffle.svg": 6450,
	"./icon-smile.svg": 3669,
	"./icon-success.svg": 8056,
	"./icon-user-small.svg": 4188,
	"./icon-user.svg": 1414,
	"./icon-userNoAvatar.svg": 5800,
	"./icon-video.svg": 8388,
	"./speak-cloud.svg": 7965
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8710;